import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarianUpdateAction from './veterinarianUpdate.action.json' with { type: 'json' }
import { veterinarianObject } from '../veterinarianObject'

const veterinarianUpdateDefinition = defineAction({
  ...veterinarianUpdateAction,

  input: veterinarianObject.partial().required({ id: true }),
  output: z.object({}),
})

export default veterinarianUpdateDefinition
